<template>
    <div ref="chart" style="width:100%;height:100%;">
    </div>
</template>

<script>
export default {
    name: "LineKeLiu",
    props: {id: Number,type: Number, wdSize: Object},
    computed: {},
    watch: {
        id(){
            this.setData()
        },
        type(){
            this.setData()
        },
        wdSize(n, o) {
            if (this.chart) {
                this.chart.resize();
                setTimeout(() => {
                    this.chart.resize();
                }, 10)
            }
        }
    },
    // created() {
    //
    // },
    data() {
        return {
            chart: null,
            option: {
                grid: {
                    bottom: 120, // 为 dataZoom 和 X 轴文字留出足够的底部空间
                },
                backgroundColor: '',
                dataZoom: [
                    {
                        type: 'slider',
                        xAxisIndex: 0,
                    },
                    {
                        type: 'inside',
                        xAxisIndex: 0,
                        zoomOnMouseWheel: 'alt',
                    },
                ],
                title: {
                    text: '客流量变化趋势',
                    textStyle: {
                        color: '#fff',
                        fontSize: 20,
                        fontWeight: 'bold',
                    },
                    subtext: 'Trend of changes in passenger flow',
                    subtextStyle: {
                        color: '#434343',
                    },
                    left: 'center',
                    
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    }
                },
                
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    axisLabel: {
                        rotate: 45,
                        margin: 20,
                    },
                    data: []
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: '{value} 条',
                        textStyle: {
                            color: "#434343",
                            margin: 15
                        },
                    },
                    axisPointer: {
                        snap: true
                    }
                },
                series: [
                    {
                        name: '客流量',
                        type: 'line',
                        smooth: true,
                        data: [],
                    }
                ]
            },
        }
    },
    methods: {
        resize() {
            // if (this.chart) {
            this.chart.resize()
            // }
        },
        setData() {

            this.$axios({
                url: `/getKLQS?id=${this.id}&type=${this.type}`,
            }).then(r => {
                let data = r.data
                this.option.xAxis.data = data.x
                this.option.series[0].data = data.y
                this.chart.setOption(this.option)
            })
            // let data = {
            //     "x": ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            //     "y": [820, 932, 901, 934, 1290, 1330, 1320]
            // }
        }

    },
    mounted() {
        this.$nextTick(() => {
            this.chart = this.$echarts.init(this.$refs.chart, 'dark');
            this.setData()
        })
    },

}
</script>

<style scoped>
</style>